import React from 'react';
import { CheckCircle } from 'lucide-react';
import type { Plan } from '@court-sync/shared';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../ui/Dialog';
import { getFullFeaturesForPlan } from './planFeatureUtils';

export interface PlanFeaturesModalProps {
  plan: Plan | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function PlanFeaturesModal({ plan, open, onOpenChange }: PlanFeaturesModalProps) {
  if (!plan) return null;

  const features = getFullFeaturesForPlan(plan);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[85vh] max-w-md overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{plan.name} features</DialogTitle>
          {plan.description ? (
            <DialogDescription>{plan.description}</DialogDescription>
          ) : null}
        </DialogHeader>
        <ul className="space-y-2" aria-label={`${plan.name} full features`}>
          {features.map((feature) => (
            <li key={feature} className="flex gap-2 text-sm text-gray-700 dark:text-gray-300">
              <CheckCircle
                className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600 dark:text-emerald-500"
                aria-hidden
              />
              <span>{feature}</span>
            </li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  );
}
